<div class="cd-panel cd-panel--from-right js-cd-panel-main {{ className }}" [ngClass]="{'cd-panel--is-visible': isVisible}">
  <div class="cd-panel__container">

    <div class="cd-panel__header">
      <a (click)="hide()" class="btn-circle btn-circle-light back-btn" *ngIf="isChildPanel"><i class="icon icon-back" aria-hidden="true"></i></a>
      <a (click)="hide()" class="btn-circle btn-circle-light" *ngIf="!isChildPanel"><i class="icon icon-close" aria-hidden="true"></i></a>
      <h2>{{ title }}</h2>
    </div>

    <div class="cd-panel__content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
<div class="cd-panel__overlay" [ngClass]="{'cd-panel--is-visible': isVisible}" *ngIf="!isChildPanel"></div>
